import { Platform } from '@cart-services/hooks/fp-b2b/store-map'
import { useFpB2bCartService } from '@cart-services/hooks/fp-b2b/use-fp-b2b-cart-service'
import { Button } from '@pets-ui/Button/Button'
import { CartFilled } from '@pets-ui/icons'
import { sumOfArray } from '@utils'
import { useMemo } from 'react'
import { useHistory } from 'react-router-dom-v5'
import { useStmCampaignCode } from '../../hooks'

interface CatalogFooterActionProps {
  basePath: string
}

export const CatalogFooterAction = (props: CatalogFooterActionProps) => {
  const { basePath } = props
  const history = useHistory()
  const { campaignId } = useStmCampaignCode()
  const { items: cartItems } = useFpB2bCartService(campaignId, Platform.STM)
  const cartTotalQuantity = useMemo(() => sumOfArray(cartItems, (acc, { quantity = 0 }) => acc + quantity), [cartItems])

  return (
    <Button color="red" startIcon={<CartFilled />} onClick={() => history.push(`${basePath}/cart`)}>
      {`(${cartTotalQuantity.toLocaleString()}) 前往購物車`}
    </Button>
  )
}
